import { render, staticRenderFns } from "./tiktokorders.vue?vue&type=template&id=4393c518&scoped=true&"
import script from "./tiktokorders.vue?vue&type=script&lang=js&"
export * from "./tiktokorders.vue?vue&type=script&lang=js&"
import style0 from "./tiktokorders.vue?vue&type=style&index=0&id=4393c518&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4393c518",
  null
  
)

export default component.exports